import { ICashRegisterModel, ICashRegisterPutModel, IOrganizationModel, IOrganizationPutModel, IPaymentMethodModel, IPaymentMethodPutModel } from "./model/IOrganizationModel";
import { DefaultResult, Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class OrganizationService extends ServiceBase {

    public async getOrganizations(

    ): Promise<Result<IOrganizationModel[]>> {
        let url = "/Organization";

        var result = await this.requestJson<IOrganizationModel[]>({
            url: url,
            method: "GET"
        });
        return result;
    }
    public async getOrganization(
        organizationId: string,
    ): Promise<Result<IOrganizationModel>> {
        let url = "/Organization/" + organizationId;

        var result = await this.requestJson<IOrganizationModel>({
            url: url,
            method: "GET"
        });
        return result;
    }

    public async putOrganizationData(
        organizationId: string, data: IOrganizationPutModel
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId;

        var result = await this.requestJsonDefault({
            url: url,
            method: "PUT",
            data: data
        })
        return result;
    }

    public async getOrganizationCashRegister(
        organizationId: string,
    ): Promise<Result<ICashRegisterModel>> {
        let url = "/Organization/" + organizationId + "/Settings/Accounting/CashRegister";

        var result = await this.requestJson<ICashRegisterModel>({
            url: url,
            method: "GET"
        });
        return result;
    }
    public async putOrganizationCashRegisterData(
        organizationId: string, data: ICashRegisterPutModel
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Settings/Accounting/CashRegister";

        var result = await this.requestJsonDefault({
            url: url,
            method: "PUT",
            data: data
        })
        return result;
    }

    public async getOrganizationCashRegisterPaymentMethods(
        organizationId: string,
    ): Promise<Result<IPaymentMethodModel[]>> {
        let url = "/Organization/" + organizationId + "/Settings/Accounting/CashRegister/PaymentMethods";

        var result = await this.requestJson<IPaymentMethodModel[]>({
            url: url,
            method: "GET"
        });
        return result;
    }
    public async postOrganizationCashRegisterPaymentMethod(
        organizationId: string, name: string, accountNo: number
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Settings/Accounting/CashRegister/PaymentMethods";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: { name: name, accountNo: accountNo }
        });
        return result;
    }
    public async putOrganizationCashRegisterPaymentMethodData(
        organizationId: string, id: number, data: IPaymentMethodPutModel
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/Settings/Accounting/CashRegister/PaymentMethods/" + id;

        var result = await this.requestJsonDefault({
            url: url,
            method: "PUT",
            data: data
        })
        return result;
    }
}